import { Component, inject } from '@angular/core';
import { VersionUpdateService } from '../../services/version-update.service';
import { ActionModalComponent } from '@premotec/pmt-bootstrap';
import { TranslocoPipe } from '@jsverse/transloco';


@Component({
    selector: 'app-version-update-modal',
    templateUrl: './version-update-modal.component.html',
    styleUrl: './version-update-modal.component.scss',
    imports: [ActionModalComponent, TranslocoPipe]
})
export class VersionUpdateModalComponent {
    private readonly versionUpdateService = inject(VersionUpdateService);


    public onSubmit(): void {
        this.versionUpdateService.reloadPageAndRefreshCache();
    }

}
